import React from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import ContentPage from './ContentPage';
import { seo } from '../../seo/seoData';
import { getPageContent } from '../../content/pages';

// ContentRoute — the GENERIC host for authored static content pages. A future page is created with
// NO bespoke React component: author a content module, register it in PAGE_CONTENT, add a seoData
// entry + a route registry entry, and point the route element at <ContentRoute seoKey="…"/>.
//
// Fail-closed: if the seoKey has no registered content OR no metadata, redirect home rather than
// render an empty/thin page. Services keep their own catalogue-driven host (ServicePage); both
// render through the same <ContentPage>.
export default function ContentRoute({ seoKey }) {
  const location = useLocation();
  const blocks = getPageContent(seoKey);
  if (!blocks || !seo[seoKey]) return <Navigate to="/" replace />;
  return (
    <ContentPage
      seoKey={seoKey}
      path={location.pathname}
      blocks={blocks}
      testId={`content-route-${seoKey}`}
    />
  );
}
